const translations = {
  en: {
    nav: {
      home: "Home",
      inventory: "Inventory",
      request: "Submit a Request",
      admin: "Admin",
      language: "FR",
    },
    hero: {
      overline: "FORKLIFT SERVICE — QUEBEC",
      title: "Find the Right Forklift. Fast.",
      subtitle: "We cross-reference your needs with available inventory — new and used — so you get results, not a sales pitch.",
      cta_browse: "Browse Inventory",
      cta_request: "Tell Us What You Need",
    },
    about: {
      title: "Practical Service, Real Results",
      p1: "We're not a big corporation. We're a focused service that connects buyers with the right forklift — whether it's new or used, propane, diesel, or electric.",
      p2: "Submit your criteria and we instantly match you with available units. No waiting, no runaround.",
      stat1_label: "MATCHED",
      stat1_desc: "Customer requests fulfilled",
      stat2_label: "INVENTORY",
      stat2_desc: "Units in our network",
      stat3_label: "RESPONSE",
      stat3_desc: "Same-day matching",
    },
    inventory: {
      title: "Available Forklifts",
      subtitle: "Browse our current inventory of new and used forklifts",
      filter_condition: "Condition",
      filter_engine: "Engine Type",
      filter_mast: "Mast Stages",
      filter_tires: "Tire Type",
      filter_drive: "Drive",
      filter_capacity: "Capacity (lbs)",
      filter_price: "Max Price",
      clear_filters: "Clear Filters",
      no_results: "No forklifts match your current filters. Try adjusting your criteria or submit a request and we'll notify you when something comes in.",
      condition_new: "New",
      condition_used: "Used",
      condition_any: "Any",
      engine_propane: "Propane",
      engine_diesel: "Diesel",
      engine_electric: "Electric",
      engine_any: "Any",
      mast_2: "2 Stages",
      mast_3: "3 Stages",
      mast_any: "Any",
      tire_pneumatic: "Pneumatic",
      tire_cushion: "Cushion",
      tire_any: "Any",
      drive_2wd: "2WD",
      drive_4wd: "4WD",
      drive_any: "Any",
      lbs: "lbs",
      hours: "hours",
      view_details: "View Details",
      apply_filters: "Apply Filters",
    },
    request: {
      title: "Tell Us What You Need",
      subtitle: "Fill in your criteria and we'll instantly show you matching forklifts. We'll also notify you when new inventory matches your needs.",
      name: "Full Name",
      email: "Email Address",
      phone: "Phone Number",
      capacity_range: "Capacity Range (lbs)",
      min: "Min",
      max: "Max",
      engine_type: "Engine Type",
      mast_stages: "Mast Stages",
      tire_type: "Tire Type",
      drive: "Drive",
      condition: "Condition",
      budget: "Maximum Budget ($)",
      notes: "Additional Notes",
      notes_placeholder: "Any specific requirements or preferences...",
      submit: "Find Matching Forklifts",
      success_title: "Request Submitted!",
      success_text: "We found matches for your criteria. Save your request ID to check back for updates.",
      your_request_id: "Your Request ID",
      matches_found: "matches found",
      view_matches: "View Matches",
      no_matches: "No matches found right now, but we'll notify you when something comes in.",
    },
    request_status: {
      title: "Your Request",
      check_title: "Check Your Request",
      check_subtitle: "Enter your request ID to see your matches and update your criteria.",
      request_id: "Request ID",
      check: "Check Status",
      matches: "Matching Forklifts",
      no_matches: "No matches yet. We'll notify you when we find something.",
      edit: "Edit Criteria",
      save: "Save Changes",
      cancel: "Cancel",
      status: "Status",
      updated: "Criteria updated successfully!",
    },
    forklift_card: {
      capacity: "Capacity",
      engine: "Engine",
      mast: "Mast",
      tires: "Tires",
      drive: "Drive",
      year: "Year",
      hours: "Hours",
      stages: "stages",
    },
    footer: {
      tagline: "Fast, practical forklift service in Quebec.",
      rights: "All rights reserved.",
    },
  },
  fr: {
    nav: {
      home: "Accueil",
      inventory: "Inventaire",
      request: "Soumettre une demande",
      admin: "Admin",
      language: "EN",
    },
    hero: {
      overline: "SERVICE DE CHARIOTS ELEVATEURS — QUEBEC",
      title: "Trouvez le bon chariot. Rapidement.",
      subtitle: "Nous croisons vos besoins avec l'inventaire disponible — neuf et usag\u00e9 — pour des r\u00e9sultats concrets, pas un discours de vente.",
      cta_browse: "Parcourir l'inventaire",
      cta_request: "Dites-nous ce qu'il vous faut",
    },
    about: {
      title: "Service pratique, r\u00e9sultats concrets",
      p1: "Nous ne sommes pas une grande corporation. Nous sommes un service cibl\u00e9 qui connecte les acheteurs avec le bon chariot \u00e9l\u00e9vateur — neuf ou usag\u00e9, propane, diesel ou \u00e9lectrique.",
      p2: "Soumettez vos crit\u00e8res et nous vous jumelerons instantan\u00e9ment avec les unit\u00e9s disponibles. Pas d'attente, pas de d\u00e9tour.",
      stat1_label: "JUMEL\u00c9S",
      stat1_desc: "Demandes clients r\u00e9pondues",
      stat2_label: "INVENTAIRE",
      stat2_desc: "Unit\u00e9s dans notre r\u00e9seau",
      stat3_label: "R\u00c9PONSE",
      stat3_desc: "Jumelage le jour m\u00eame",
    },
    inventory: {
      title: "Chariots disponibles",
      subtitle: "Parcourez notre inventaire actuel de chariots \u00e9l\u00e9vateurs neufs et usag\u00e9s",
      filter_condition: "Condition",
      filter_engine: "Type de moteur",
      filter_mast: "Stages du m\u00e2t",
      filter_tires: "Type de pneus",
      filter_drive: "Traction",
      filter_capacity: "Capacit\u00e9 (lbs)",
      filter_price: "Prix max",
      clear_filters: "Effacer les filtres",
      no_results: "Aucun chariot ne correspond \u00e0 vos filtres. Ajustez vos crit\u00e8res ou soumettez une demande et nous vous aviserons.",
      condition_new: "Neuf",
      condition_used: "Usag\u00e9",
      condition_any: "Tous",
      engine_propane: "Propane",
      engine_diesel: "Diesel",
      engine_electric: "\u00c9lectrique",
      engine_any: "Tous",
      mast_2: "2 Stages",
      mast_3: "3 Stages",
      mast_any: "Tous",
      tire_pneumatic: "Pneumatique",
      tire_cushion: "Coussin",
      tire_any: "Tous",
      drive_2wd: "2RM",
      drive_4wd: "4RM",
      drive_any: "Tous",
      lbs: "lbs",
      hours: "heures",
      view_details: "Voir d\u00e9tails",
      apply_filters: "Appliquer les filtres",
    },
    request: {
      title: "Dites-nous ce qu'il vous faut",
      subtitle: "Remplissez vos crit\u00e8res et nous vous montrerons instantan\u00e9ment les chariots correspondants. Nous vous aviserons aussi lorsque de nouveaux inventaires correspondent \u00e0 vos besoins.",
      name: "Nom complet",
      email: "Adresse courriel",
      phone: "Num\u00e9ro de t\u00e9l\u00e9phone",
      capacity_range: "Plage de capacit\u00e9 (lbs)",
      min: "Min",
      max: "Max",
      engine_type: "Type de moteur",
      mast_stages: "Stages du m\u00e2t",
      tire_type: "Type de pneus",
      drive: "Traction",
      condition: "Condition",
      budget: "Budget maximum ($)",
      notes: "Notes suppl\u00e9mentaires",
      notes_placeholder: "Exigences ou pr\u00e9f\u00e9rences sp\u00e9cifiques...",
      submit: "Trouver des chariots",
      success_title: "Demande soumise!",
      success_text: "Nous avons trouv\u00e9 des correspondances. Conservez votre ID de demande pour v\u00e9rifier les mises \u00e0 jour.",
      your_request_id: "Votre ID de demande",
      matches_found: "correspondances trouv\u00e9es",
      view_matches: "Voir les correspondances",
      no_matches: "Aucune correspondance pour le moment, mais nous vous aviserons.",
    },
    request_status: {
      title: "Votre demande",
      check_title: "V\u00e9rifier votre demande",
      check_subtitle: "Entrez votre ID de demande pour voir vos correspondances et mettre \u00e0 jour vos crit\u00e8res.",
      request_id: "ID de demande",
      check: "V\u00e9rifier",
      matches: "Chariots correspondants",
      no_matches: "Pas encore de correspondances. Nous vous aviserons.",
      edit: "Modifier les crit\u00e8res",
      save: "Enregistrer",
      cancel: "Annuler",
      status: "Statut",
      updated: "Crit\u00e8res mis \u00e0 jour!",
    },
    forklift_card: {
      capacity: "Capacit\u00e9",
      engine: "Moteur",
      mast: "M\u00e2t",
      tires: "Pneus",
      drive: "Traction",
      year: "Ann\u00e9e",
      hours: "Heures",
      stages: "stages",
    },
    footer: {
      tagline: "Service de chariots \u00e9l\u00e9vateurs rapide et pratique au Qu\u00e9bec.",
      rights: "Tous droits r\u00e9serv\u00e9s.",
    },
  },
};

export default translations;
